"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const rpdf_renderer_1 = require("@surge-global-engineering/rpdf-renderer");
const appearOnGivenPage_1 = require("./appearOnGivenPage");
const Header = ({ transformedPageNumber, evenPageHeaderText = '', oddPageHeaderText = '', pageHeaderAlignment = 'center', isPageNumberHidden, pageNumberContainerWidth = 30, styles, blackListedPages = [], }) => {
    const contentHeight = Number(styles === null || styles === void 0 ? void 0 : styles.fontSize) * 2 || (styles === null || styles === void 0 ? void 0 : styles.minHeight);
    // This approach uses a fixed width for the page number, as specified by `pageNumberContainerWidth`
    // The required width will vary across books based on the font-family, and font-size used.
    // Therefore, the width can be customized at the consumer level of this library (Eg: atticus-editor)
    // A proposed approach is to leave enough width to print '9999 ' (and ' 9999').
    return (jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: jsx_runtime_1.jsxs(rpdf_renderer_1.View, Object.assign({ fixed: true, style: {
                position: 'absolute',
                height: contentHeight,
                width: '100%',
                left: 0,
                top: 0,
                overflow: 'hidden',
            } }, { children: [jsx_runtime_1.jsxs(rpdf_renderer_1.View, Object.assign({ style: {
                        position: 'absolute',
                        height: contentHeight,
                        width: '100%',
                        left: 0,
                        top: 0,
                    } }, { children: [jsx_runtime_1.jsx(rpdf_renderer_1.View, Object.assign({ style: {
                                position: 'absolute',
                                height: contentHeight,
                                width: '100%',
                                left: 0,
                                top: 0,
                                paddingLeft: isPageNumberHidden ? 0 : pageNumberContainerWidth,
                            } }, { children: jsx_runtime_1.jsx(rpdf_renderer_1.Text, { style: {
                                    fontFamily: styles === null || styles === void 0 ? void 0 : styles.fontFamily,
                                    fontSize: styles === null || styles === void 0 ? void 0 : styles.fontSize,
                                    maxLines: 1,
                                    textOverflow: 'ellipsis',
                                    textAlign: pageHeaderAlignment === 'center' ? 'center' : 'left',
                                }, render: ({ pageNumber, subPageNumber }) => {
                                    return appearOnGivenPage_1.appearOnGivenPage('even', evenPageHeaderText, pageNumber, subPageNumber, blackListedPages);
                                } }, void 0) }), void 0), !isPageNumberHidden && (jsx_runtime_1.jsx(rpdf_renderer_1.View, Object.assign({ style: { display: 'flex', flex: 1 } }, { children: jsx_runtime_1.jsx(rpdf_renderer_1.Text, { style: {
                                    textAlign: 'left',
                                    fontFamily: styles === null || styles === void 0 ? void 0 : styles.fontFamily,
                                    fontSize: styles === null || styles === void 0 ? void 0 : styles.fontSize,
                                }, render: ({ pageNumber, subPageNumber }) => {
                                    return appearOnGivenPage_1.appearOnGivenPage('even', transformedPageNumber(pageNumber), pageNumber, subPageNumber, blackListedPages);
                                } }, void 0) }), void 0))] }), void 0), jsx_runtime_1.jsxs(rpdf_renderer_1.View, Object.assign({ style: {
                        position: 'absolute',
                        height: contentHeight,
                        width: '100%',
                        left: 0,
                        top: 0,
                    } }, { children: [jsx_runtime_1.jsx(rpdf_renderer_1.View, Object.assign({ style: {
                                position: 'absolute',
                                height: contentHeight,
                                width: '100%',
                                left: 0,
                                top: 0,
                                paddingRight: isPageNumberHidden ? 0 : pageNumberContainerWidth,
                            } }, { children: jsx_runtime_1.jsx(rpdf_renderer_1.Text, { style: {
                                    fontFamily: styles === null || styles === void 0 ? void 0 : styles.fontFamily,
                                    fontSize: styles === null || styles === void 0 ? void 0 : styles.fontSize,
                                    maxLines: 1,
                                    textOverflow: 'ellipsis',
                                    textAlign: pageHeaderAlignment === 'center' ? 'center' : 'right',
                                }, render: ({ pageNumber, subPageNumber }) => {
                                    return appearOnGivenPage_1.appearOnGivenPage('odd', oddPageHeaderText, pageNumber, subPageNumber, blackListedPages);
                                } }, void 0) }), void 0), !isPageNumberHidden && (jsx_runtime_1.jsx(rpdf_renderer_1.View, Object.assign({ style: { display: 'flex', flex: 1 } }, { children: jsx_runtime_1.jsx(rpdf_renderer_1.Text, { style: {
                                    textAlign: 'right',
                                    fontFamily: styles === null || styles === void 0 ? void 0 : styles.fontFamily,
                                    fontSize: styles === null || styles === void 0 ? void 0 : styles.fontSize,
                                }, render: ({ pageNumber, subPageNumber }) => {
                                    return appearOnGivenPage_1.appearOnGivenPage('odd', transformedPageNumber(pageNumber), pageNumber, subPageNumber, blackListedPages);
                                } }, void 0) }), void 0))] }), void 0)] }), void 0) }, void 0));
};
exports.default = Header;
//# sourceMappingURL=header.js.map